import { serializable, alias, primitive, list, object } from 'serializr';
import { SubscriptionTier } from '../../enums/clientEnums';

export class ClientSummary {
  @serializable(alias('id', primitive()))
  id!: number;

  @serializable(alias('clientName', primitive()))
  clientName!: string;

  @serializable(alias('paymentGroupId', primitive()))
  paymentGroupId!: number;

  @serializable(alias('archived', primitive()))
  archived!: boolean;

  @serializable(alias('deletedAt', primitive()))
  deletedAt!: string | null;
}

export class ClientAdmin {
  @serializable(alias('id', primitive()))
  id!: number;

  @serializable(alias('name', primitive()))
  name!: string;

  @serializable(alias('email', primitive()))
  email!: string;

  @serializable(alias('phone', primitive()))
  phone!: string | null;

  @serializable(alias('status', primitive()))
  status!: string;
}

export class ClientSubscription {
  @serializable(alias('id', primitive()))
  id!: number;

  @serializable(alias('type', primitive()))
  type!: SubscriptionTier;

  @serializable(alias('startsAt', primitive()))
  startsAt!: string | null;

  @serializable(alias('expiresAt', primitive()))
  expiresAt!: string | null;

  @serializable(alias('markedAsPaid', primitive()))
  markedAsPaid!: boolean;
}

// `id` is the assignment; `addonId` points at the catalogue entry the wizard's
// rows and the add-on table are keyed on.
export class ClientDetailAddOn {
  @serializable(alias('id', primitive()))
  id!: number;

  @serializable(alias('addonId', primitive()))
  addonId!: number;

  @serializable(alias('addonType', primitive()))
  addonType!: string;

  @serializable(alias('name', primitive()))
  name!: string;

  @serializable(alias('quantity', primitive()))
  quantity!: number;

  @serializable(alias('price', primitive()))
  price!: number;

  @serializable(alias('expiresAt', primitive()))
  expiresAt!: string | null;

  // Server-calculated; the frontend never compares dates itself.
  @serializable(alias('isExpired', primitive()))
  isExpired!: boolean;

  @serializable(alias('addonLength', primitive()))
  addonLength!: number | null;
}

export class ClientPaymentInfo {
  @serializable(alias('contactName', primitive()))
  contactName!: string;

  @serializable(alias('contactEmail', primitive()))
  contactEmail!: string;

  @serializable(alias('contactPhone', primitive()))
  contactPhone!: string | null;

  @serializable(alias('paymentMethod', primitive()))
  paymentMethod!: string;
}

export class ClientDetails {
  @serializable(object(ClientSummary))
  client!: ClientSummary;

  // Seed/legacy clients can have these null outright, not just missing sub-fields.
  @serializable(object(ClientAdmin))
  admin!: ClientAdmin | null;

  @serializable(object(ClientSubscription))
  subscription!: ClientSubscription | null;

  @serializable(list(object(ClientDetailAddOn)))
  addons!: ClientDetailAddOn[];

  @serializable(object(ClientPaymentInfo))
  paymentInfo!: ClientPaymentInfo | null;
}
